import { render, staticRenderFns } from "./HeaderNavigationDrawer.vue?vue&type=template&id=28b04c52&scoped=true"
import script from "./HeaderNavigationDrawer.vue?vue&type=script&lang=ts"
export * from "./HeaderNavigationDrawer.vue?vue&type=script&lang=ts"
import style0 from "./HeaderNavigationDrawer.vue?vue&type=style&index=0&id=28b04c52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b04c52",
  null
  
)

export default component.exports